import React, { useState } from "react";
import { BiUser } from "react-icons/bi";
import Logo from "../../Assets/Svg/mindcareLogo2.svg";
import { CiCircleInfo } from "react-icons/ci";
import Teen from "../../Assets/Images/Adult.png";
import child from "../../Assets/Images/child.png";
import Individual from "../../Assets/Images/Adult2.png";
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import { individualQuestions_Level1, individualQuestions_Level2, categoryThresholds } from "../../Components/data/Questions";
import { teenQuestions_Level1, teenLevel2Questions, teen_Level2Questions, teenLevel1Questions, } from "../../Components/data/TeenQuestions";
import { childLevel2Questions, childQuestions_Level1 } from "../../Components/data/ChildQuestions";


const Questions = () => {
  const [qno, setQno] = useState(0);
  const [selected, setSelected] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [selectedTherapy, setSelectedTherapy] = useState(null); // Added state to manage selected therapy
  const [scores, setScores] = useState({
    depression: 0,
    anxiety: 0,
    mania: 0,
    anger: 0,
    sleep: 0,
    SomaticSymptoms: 0,
    ThoughtsAndBehaviors: 0,
    SubstanceUse: 0,

  });
  const [level, setLevel] = useState(1);
  const [isCompleted, setIsCompleted] = useState(false);
  const [assessmentResult, setAssessmentResult] = useState(null);

  const question = questions[qno];

  const handleCardClick = (therapyType) => {
    if (therapyType === "individual") {
      setQuestions(individualQuestions_Level1);
    } else if (therapyType === "teen") {
      setQuestions(teenLevel1Questions);
    } else if (therapyType === "child") {
      setQuestions(childQuestions_Level1);
    }
    setSelectedTherapy(therapyType); // Set the selected therapy type
    // Reset scores when switching therapy type
    setScores({
      anxiety: 0,
      depression: 0,
      stress: 0,
      academic_stress: 0,
      // Add other categories as needed
    });
    setLevel(1);
    setQno(0);
  };

  const calculateScores = (answer, currentQuestion) => {
    if (!currentQuestion.category || currentQuestion.category === 'demographic') {
      return; // Skip scoring for demographic questions
    }

    const scoreIndex = currentQuestion.options.indexOf(answer);
    const score = currentQuestion.scores[scoreIndex];

    setScores(prevScores => ({
      ...prevScores,
      [currentQuestion.category]: (prevScores[currentQuestion.category] || 0) + score
    }));
  };

  // const moveToLevel2 = () => {
  //   // Find the category with the highest score that exceeds its threshold
  //   const highestCategory = Object.entries(scores)
  //     .filter(([category, score]) => score >= categoryThresholds[category])
  //     .reduce((max, [category, score]) => 
  //       score > (scores[max] || 0) ? category : max,
  //       null
  //     );

  //   if (!highestCategory || !individualQuestions_Level2[highestCategory]) {
  //     console.log('No category qualified for level 2 or no level 2 questions available');
  //     // Handle completion or show results
  //     return;
  //   }

  //   console.log(`Moving to level 2 questions for ${highestCategory}`);
  //   setQuestions(individualQuestions_Level2[highestCategory]);
  //   setLevel(2);
  //   setQno(0);
  //   setSelected(null);
  // };

  const moveToLevel2 = () => {
    const highestCategory = Object.entries(scores)
      .filter(([category, score]) => score >= categoryThresholds[category])
      .reduce((max, [category, score]) =>
        score > (scores[max] || 0) ? category : max,
        null
      );

    if (!highestCategory) {
      console.log('No category qualified for level 2', highestCategory);
      return;
    }

    // Choose level 2 questions based on therapy type
    let level2QuestionSet;
    if (selectedTherapy === "teen") {
      level2QuestionSet = teen_Level2Questions;
    } else if (selectedTherapy === "child") {
      level2QuestionSet = childLevel2Questions;
    } else {
      level2QuestionSet = individualQuestions_Level2;
    }

    if (!level2QuestionSet[highestCategory]) {
      console.log('No level 2 questions available for category:', highestCategory);
      return;
    }

    console.log(`Moving to level 2 ${selectedTherapy} questions for ${highestCategory}`);
    setQuestions(level2QuestionSet[highestCategory]);
    setLevel(2);
    setQno(0);
    setSelected("");
  };

  const handleBack = () => {
    if (qno > 0) {
      setQno(qno - 1);
      setSelected(null);
    }
  };

  const handleNext = () => {
    if (selected === null) return;

    calculateScores(selected, question);

    if (qno < questions.length - 1) {
      setQno(qno + 1);
      setSelected(null);
    } else if (level === 1) {
      moveToLevel2();
    } else {
      // Handle completion of level 2
      console.log('Assessment completed', scores);
      setIsCompleted(true);
      generateAssessmentResult();
      // Add your completion logic here
    }
  };

  const generateAssessmentResult = () => {
    const getSpecificMessage = () => {
      const highestScore = Object.entries(scores).reduce(
        (max, [category, score]) => (score > max.score ? { category, score } : max),
        { category: '', score: -1 }
      );

      const categoryMessages = {
        anxiety: "Your responses indicate you've been experiencing some anxiety. This is very common, and there are effective ways to manage it.",
        depression: "You've shown courage in sharing your feelings of depression. Remember, you're not alone, and help is available.",
        anger: "Managing anger can be challenging, but with the right support, you can develop effective coping strategies.",
        // Add more category-specific messages
      };

      return categoryMessages[highestScore.category] || "";
    };

    const messages = {
      child: {
        title: "Assessment Complete",
        message: `${getSpecificMessage()} Your child's responses help us understand how to support their emotional well-being.`,
        nextSteps: "A child specialist will connect with you soon to provide personalized guidance."
      },
      teen: {
        title: "Thank you for completing your assessment",
        message: `${getSpecificMessage()} Many teens face similar challenges, and seeking support is a sign of strength, not weakness.`,
        nextSteps: "Our teen counseling specialists will be in touch soon to discuss your next steps."
      },
      individual: {
        title: "Assessment Complete",
        message: `${getSpecificMessage()} Your responses help us understand how to best support your mental health journey.`,
        nextSteps: "We'll match you with a therapist who specializes in your specific needs."
      }
    };

    setAssessmentResult(messages[selectedTherapy]);
  };

  return (
    <div className="bg-secondary">
      <div className="flex px-10">
        <div className="navbar h-[45px] fixed w-full z-20 top-0 left-0 px-[5%] flex justify-between items-center py-[0.35rem] bg-white/60 border-b backdrop-blur-sm dark:border-dark dark:bg-card-dark/60">
          <div className="flex items-center">
            <img src={Logo} alt="" />
            <h2 className="text-accent font-semibold">
              <span className="text-2xl text-accent font-bold font-serif">
                M
              </span>
              indCare
            </h2>
          </div>
          <div className="border rounded-full bg-white/70 shadow cursor-pointer p-2 icon-box dark:bg-dark-light hover:shadow-xl">
            <BiUser className="text-accent h-4 w-4 hover:scale-125 transition duration-300" />
          </div>
        </div>
      </div>

      <div className="flex flex-col bg-accent min-h-screen justify-center items-center pt-10 pb-40">
        {!selectedTherapy ? (
          <div>
            <div className="flex flex-col items-center my-10">
              <h2 className="text-2xl font-[500] text-white">
                Your journey to healing starts here.
              </h2>
              <p className="mt-3 text-sm text-white/80">
                What kind of therapy feels right for you
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
              <div
                className=" group px-6 py-3 bg-[#E5B037] relative shadow-md rounded-lg text-center cursor-pointer  border-2 border-[#E5B037]  hover:border-2 hover:border-[#fff] hover:text-white transition"
                onClick={() => handleCardClick("child")}
              >
                <h3 className="text-lg  text-[#A01C0A] text-center uppercase font-bold">
                  Child{" "}
                </h3>

                <img
                  src={child} // Replace with appropriate image/icon path
                  alt="Child Therapy"
                  className="mx-auto mb-4 h-52 w-32 group-hover:scale-110 transition duration-700"
                />

                <div className=" absolute z-10 px-5 h-10 w-full bottom-0 left-0 rounded-tr-full rounded-b-lg bg-[#A01C0A]">
                  <p className="text-left text-xs text-[#E5B037]">
                    For my child
                  </p>
                  <div className="flex justify-start items-center gap-2 group-hover:text-white transition">
                    <button className="group-hover:underline text-sm text-[#E5B037]">
                      Click Here
                    </button>
                    <i>
                      <IoArrowForwardCircleOutline />
                    </i>
                  </div>
                </div>
              </div>
              <div
                className="group px-6 py-2 bg-[#52a4ca] relative shadow-md rounded-md h-[300px] text-center border-2 border-[#52a4ca] cursor-pointer hover:border-white transition"
                onClick={() => handleCardClick("teen")}
              >
                <h3 className="text-lg text-center uppercase text-[#273b53] font-bold transition">
                  Teen
                </h3>

                <img
                  src={Teen} // Replace with appropriate image/icon path
                  alt="Teen Therapy"
                  className="mx-auto mb-4 h-52 w-28 mt-2 group-hover:scale-110 transition duration-700"
                />

                <div className="absolute px-5 h-10 w-full bottom-0 left-0 rounded-tr-full rounded-b-lg bg-[#273b53]  transition">
                  <p className="text-left text-xs text-[#52a4ca]  transition">
                    For my child
                  </p>
                  <div className="flex justify-start items-center gap-2 group-hover:text-white transition">
                    <button className="group-hover:underline text-sm text-[#52a4ca]">
                      Click Here
                    </button>
                    <i>
                      <IoArrowForwardCircleOutline />
                    </i>
                  </div>
                </div>
              </div>

              <div
                className="group px-6 py-3 bg-[#FFB64D] relative shadow-md rounded-lg text-center cursor-pointer border-2 border-[#FFB64D] hover:border-2 hover:border-white  transition"
                onClick={() => handleCardClick("individual")}
              >
                <h3 className="text-lg text-center uppercase text-[#6e4b1a] font-bold">
                  Individual{" "}
                </h3>

                <img
                  src={Individual} // Replace with appropriate image/icon path
                  alt="Individual Therapy"
                  className="mx-auto my-2 h-48 w-40 group-hover:scale-110 transition duration-700"
                />
                <div className=" absolute px-5 h-10 w-full bottom-0 left-0 rounded-tr-full rounded-b-lg bg-[#6e4b1a]">
                  <p className="text-left text-xs text-[#FFB64D]">For myself</p>
                  <div className="flex justify-start items-center gap-2 group-hover:text-white transition">
                    <button className="group-hover:underline text-sm text-[#FFB64D]">
                      Click Here
                    </button>
                    <i>
                      <IoArrowForwardCircleOutline />
                    </i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : isCompleted ? (
          // Completion Card
          <div className="bg-white rounded-lg shadow-xl p-4 w-[500px] mt-10 mx-4 text-center">
            <div className="mb-6">
              <div className="w-20 h-20 bg-green-100 rounded-full mx-auto flex items-center justify-center">
                <svg
                  className="w-10 h-10 text-green-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
            </div>

            <h2 className="text-xl font-bold text-gray-800 mb-4">
              {assessmentResult?.title}
            </h2>

            <p className="text-gray-600 mb-6 text-sm">
              {assessmentResult?.message}
            </p>

            <div className="bg-blue-50 p-4 rounded-lg mb-6">
              <p className="text-blue-800 text-sm">
                {assessmentResult?.nextSteps}
              </p>
            </div>

            <div className="flex flex-col gap-4">
              <button
                onClick={() => window.location.reload()}
                className="px-6 py-3 bg-accent text-white rounded-full hover:bg-accent/80 transition duration-300"
              >
                Start New Assessment
              </button>

              <button
                onClick={() => {/* Add navigation to home/dashboard */ }}
                className="px-6 py-3 border border-accent text-accent rounded-full hover:bg-accent/10 transition duration-300"
              >
                Return to Home
              </button>
            </div>
          </div>
        ) : (
          <>
            <h2 className="mt-8 text-3xl justify-end text-white font-serif">
              Allow us to find the right therapist to{" "}
              <span className="text-primary">support your journey</span>
            </h2>
            <h2 className=" text-white/80 text-xs text-center mt-5">
              Finding the right therapist is essential for building a personal
              connection that supports your mental health journey. The following
              questions <br /> are tailored to understand your unique needs and
              preferences, helping you connect with a licensed therapist who is
              the best fit for you.
            </h2>
            <div className="px-8 py-6 w-[400px] my-14 bg-white border shadow-md rounded-md">
              <div className="flex flex-col">


                <div className="font-normal text-sm mb-2">
                  {question.question}
                </div>
                {question.inputType === "select" && (
                  <select
                    value={selected}
                    onChange={(e) => setSelected(e.target.value)}
                    className="p-2 border rounded-md mt-2"
                  >
                    <option value="">Select an option</option>
                    {question.options.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                )}
                {/* {question.inputType === "select" && (
                  <div className="relative mt-2 w-full max-w-md">
                    <select
                      value={selected}
                      onChange={(e) => setSelected(e.target.value)}
                      className="block w-full appearance-none bg-white border border-gray-300 text-gray-700 py-2 px-4 pr-10 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="" disabled>
                        Select an option
                      </option>
                      {question.options.map((option, index) => (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>

                    {/* Down Arrow Icon */}
                    {/* <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-400">
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </div>
                  </div>
                )} */}

                {question.inputType === "radio" &&
                  question.options.map((option, index) => (
                    <button
                      key={index}
                      onClick={() => setSelected(option)}
                      className={`px-4 py-2 mt-2 mr-2 rounded-full text-left font-normal text-sm ${selected === option
                        ? "bg-primary text-white"
                        : "bg-accent/40 text-black"
                        } hover:bg-primary hover:text-white`}
                    >
                      {option}
                    </button>
                  ))}

                <div className="flex items-center justify-end mt-4 gap-3">
                  {qno > 0 && (
                    <button
                      onClick={handleBack}
                      className="px-5 py-2 bg-primary hover:bg-accent text-white rounded-full"
                    >
                      Back
                    </button>
                  )}
                  <button
                    onClick={handleNext}
                    disabled={!selected}
                    className={`px-5 py-2 ${selected
                      ? "bg-accent/40 hover:bg-accent hover:text-white"
                      : "bg-gray-300"
                      } rounded-full`}
                  >
                    {qno < questions.length - 1 ? "Next" : "Finish"}
                  </button>
                </div>
                {qno > 0 && (
                  <div className="bg-cyan-100 mt-5 rounded p-3 flex items-start">
                    <CiCircleInfo className="h-10 w-6 mr-3 stroke-1 text-cyan-400" />
                    <p className="text-xs text-primaraytext">
                      These questions help match you with a licensed therapist
                      who fits your needs and preferences.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Questions;
